// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../lib/api';
import { PackCheckLogo } from '../components/PackCheckLogo';
import { CheckCircle2, XCircle } from 'lucide-react';

export default function GmailConnectCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const [status, setStatus] = useState('processing'); // processing | done | error
  const [message, setMessage] = useState('');
  const processed = React.useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const search = new URLSearchParams(loc.search || window.location.search);
    const code = search.get('code');
    const state = search.get('state');
    const err = search.get('error');
    if (err) {
      setStatus('error');
      setMessage(`Google returned: ${err}`);
      return;
    }
    if (!code || !state) {
      setStatus('error');
      setMessage('Missing code or state from Google');
      return;
    }
    (async () => {
      try {
        const redirectUri = window.location.origin + '/gmail-connect';
        const { data } = await api.post(
          `/account/gmail/callback?state=${encodeURIComponent(state)}`,
          { code, redirect_uri: redirectUri }
        );
        setStatus('done');
        setMessage(`Connected as ${data.sender_email || 'Gmail account'}`);
        setTimeout(() => nav('/account', { replace: true }), 1800);
      } catch (e) {
        setStatus('error');
        setMessage(e?.response?.data?.detail || e.message || 'Gmail connect failed');
      }
    })();
  }, [loc, nav]);

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-8"><PackCheckLogo height={36} /></div>
        {status === 'processing' && (
          <>
            <div className="dot-loader mx-auto"><span/><span/><span/></div>
            <p className="mt-6 text-sm text-muted-foreground" data-testid="gmail-status">Finalising Gmail connection…</p>
          </>
        )}
        {status === 'done' && (
          <>
            <CheckCircle2 size={40} className="mx-auto text-severity-low" strokeWidth={1.4} />
            <p className="mt-4 font-medium" data-testid="gmail-status">{message}</p>
            <p className="mt-2 text-xs text-muted-foreground">Returning to admin…</p>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle size={40} className="mx-auto text-severity-high" strokeWidth={1.4} />
            <p className="mt-4 font-mono text-sm text-severity-high max-w-sm" data-testid="gmail-error">{message}</p>
            <button onClick={() => nav('/account')} className="mt-6 underline text-sm">Back to account</button>
          </>
        )}
      </div>
    </div>
  );
}
